const scrollTo = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const navGroups = [
  {
    title: 'Explore',
    links: [
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Testimonials', href: '#testimonials' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Book a Consultation', href: '#consultation' },
    ],
  },
];

const socials = [
  { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
  { icon: 'ri-pinterest-line', label: 'Pinterest', href: '#' },
  { icon: 'ri-facebook-circle-line', label: 'Facebook', href: '#' },
];

export default function FooterSection() {
  return (
    <footer className="px-6 lg:px-12 pt-20 pb-8" style={{ background: '#2A1D0E' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 pb-16 border-b border-white/10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a
              href="#home"
              onClick={(e) => { e.preventDefault(); scrollTo('#home'); }}
              className="cursor-pointer"
            >
              <h2
                className="text-2xl tracking-widest mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: '#FAF7F3', letterSpacing: '0.18em', fontWeight: 300 }}
              >
                Dreamline Bridal
              </h2>
            </a>
            <p
              className="text-sm text-stone-400 mb-6 max-w-xs leading-relaxed"
              style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
            >
              Where every bride&apos;s vision becomes a masterpiece. Bespoke luxury wedding gowns, crafted with care and shipped worldwide.
            </p>
            <div className="flex gap-4">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  rel="nofollow"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-sm border border-white/10 text-stone-400 hover:text-amber-400 hover:border-amber-400/40 transition-all duration-300 cursor-pointer"
                >
                  <i className={social.icon} style={{ fontSize: '1rem' }} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav Columns */}
          {navGroups.map((group) => (
            <div key={group.title}>
              <p
                className="text-xs tracking-widest uppercase text-amber-500/70 mb-5"
                style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.18em', fontSize: '0.65rem' }}
              >
                {group.title}
              </p>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                      className="text-sm text-stone-400 hover:text-amber-300 transition-colors duration-200 cursor-pointer"
                      style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact Column */}
          <div>
            <p
              className="text-xs tracking-widest uppercase text-amber-500/70 mb-5"
              style={{ fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.18em', fontSize: '0.65rem' }}
            >
              Contact
            </p>
            <div className="flex flex-col gap-2">
              <p
                className="text-sm text-stone-400"
                style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
              >
                hello@dreamlinebridal.com
              </p>
              <p
                className="text-sm text-stone-500"
                style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
              >
                Mon – Fri, 9am – 6pm EST
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-xs text-stone-600"
            style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            &copy; 2026 Dreamline Bridal. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Privacy Policy', 'Terms of Service'].map((item) => (
              <a
                key={item}
                href="#"
                rel="nofollow"
                className="text-xs text-stone-600 hover:text-stone-400 transition-colors duration-200 cursor-pointer"
                style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>

        {/* Watermark */}
        <div className="mt-8 overflow-hidden select-none pointer-events-none">
          <p
            className="text-center whitespace-nowrap"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(3rem, 8vw, 7rem)',
              color: 'rgba(255,255,255,0.03)',
              letterSpacing: '0.1em',
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            DREAMLINE
          </p>
        </div>
      </div>
    </footer>
  );
}
